import type {
  AustralianState,
  StampDutyBracket,
  StampDutyResult,
} from '../types';

export const STAMP_DUTY_BRACKETS: Record<
  AustralianState,
  StampDutyBracket[]
> = {
  NSW: [
    { minPropertyValue: 0, maxPropertyValue: 17_000, baseDutyAud: 0, rateOnExcessPer100: 1.25, foreignBuyerSurchargePct: 9 },
    { minPropertyValue: 17_001, maxPropertyValue: 36_000, baseDutyAud: 212, rateOnExcessPer100: 1.5, foreignBuyerSurchargePct: 9 },
    { minPropertyValue: 36_001, maxPropertyValue: 97_000, baseDutyAud: 497, rateOnExcessPer100: 1.75, foreignBuyerSurchargePct: 9 },
    { minPropertyValue: 97_001, maxPropertyValue: 364_000, baseDutyAud: 1_564, rateOnExcessPer100: 3.5, foreignBuyerSurchargePct: 9 },
    { minPropertyValue: 364_001, maxPropertyValue: 1_212_000, baseDutyAud: 10_909, rateOnExcessPer100: 4.5, foreignBuyerSurchargePct: 9 },
    { minPropertyValue: 1_212_001, maxPropertyValue: 3_636_000, baseDutyAud: 49_069, rateOnExcessPer100: 5.5, foreignBuyerSurchargePct: 9 },
  ],
  VIC: [
    { minPropertyValue: 0, maxPropertyValue: 130_000, baseDutyAud: 0, rateOnExcessPer100: 2.2, foreignBuyerSurchargePct: 8 },
    { minPropertyValue: 130_001, maxPropertyValue: 960_000, baseDutyAud: 2_870, rateOnExcessPer100: 6.0, foreignBuyerSurchargePct: 8 },
    { minPropertyValue: 960_001, maxPropertyValue: 2_000_000, baseDutyAud: 52_670, rateOnExcessPer100: 5.5, foreignBuyerSurchargePct: 8 },
  ],
  QLD: [
    { minPropertyValue: 0, maxPropertyValue: 540_000, baseDutyAud: 0, rateOnExcessPer100: 3.5, foreignBuyerSurchargePct: 8 },
    { minPropertyValue: 540_001, maxPropertyValue: 1_000_000, baseDutyAud: 17_325, rateOnExcessPer100: 4.5, foreignBuyerSurchargePct: 8 },
    { minPropertyValue: 1_000_001, maxPropertyValue: 9_999_999, baseDutyAud: 38_025, rateOnExcessPer100: 5.75, foreignBuyerSurchargePct: 8 },
  ],
  WA: [
    { minPropertyValue: 0, maxPropertyValue: 120_000, baseDutyAud: 0, rateOnExcessPer100: 1.9, foreignBuyerSurchargePct: 7 },
    { minPropertyValue: 120_001, maxPropertyValue: 150_000, baseDutyAud: 2_280, rateOnExcessPer100: 2.85, foreignBuyerSurchargePct: 7 },
    { minPropertyValue: 150_001, maxPropertyValue: 360_000, baseDutyAud: 3_135, rateOnExcessPer100: 3.8, foreignBuyerSurchargePct: 7 },
    { minPropertyValue: 360_001, maxPropertyValue: 725_000, baseDutyAud: 11_115, rateOnExcessPer100: 4.75, foreignBuyerSurchargePct: 7 },
    { minPropertyValue: 725_001, maxPropertyValue: 9_999_999, baseDutyAud: 28_453, rateOnExcessPer100: 5.15, foreignBuyerSurchargePct: 7 },
  ],
  SA: [
    { minPropertyValue: 0, maxPropertyValue: 9_999_999, baseDutyAud: 0, rateOnExcessPer100: 5.0, foreignBuyerSurchargePct: 7 },
  ],
  ACT: [
    { minPropertyValue: 0, maxPropertyValue: 9_999_999, baseDutyAud: 0, rateOnExcessPer100: 5.0, foreignBuyerSurchargePct: 0 },
  ],
};

export function calculateStampDuty(
  price: number,
  brackets: StampDutyBracket[],
  isForeign: boolean,
): StampDutyResult {
  let base = price * 0.05;
  let foreignSurchargePct = 0;

  for (const b of brackets) {
    if (price >= b.minPropertyValue && price <= b.maxPropertyValue) {
      base =
        b.baseDutyAud +
        ((price - b.minPropertyValue) / 100) * b.rateOnExcessPer100;
      foreignSurchargePct = b.foreignBuyerSurchargePct;
      break;
    }
  }

  const foreign = isForeign ? price * (foreignSurchargePct / 100) : 0;

  return {
    base: Math.round(base),
    foreign: Math.round(foreign),
    total: Math.round(base + foreign),
  };
}
